const THEME_KEY = 'bf_theme';

export function getPreferredTheme() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(THEME_KEY);
  }

  return 'light';
}

export function applyTheme() {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', 'light');
}

export function initTheme() {
  getPreferredTheme();
  applyTheme();
  return 'light';
}

export function setTheme() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(THEME_KEY);
  }
  applyTheme();
  return 'light';
}

export function toggleTheme() {
  return setTheme();
}

export function readTheme() {
  return 'light';
}
